import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const menuItems = [
  { path: '/dashboard', label: 'Beranda', icon: '⌂' },
  { path: '/monitoring', label: 'Monitoring PSRI', icon: '◎' },
  { path: '/inspeksi', label: 'Riwayat Inspeksi', icon: '⧗' },
  { path: '/temuan', label: 'Temuan', icon: '⚠' },
  { path: '/peta-apar', label: 'Peta Sebaran APAR', icon: '📍' },
];

const pengaturanItems = [
  { path: '/users', label: 'Manajemen User', icon: '◈' },
  { path: '/apar', label: 'Generate QR APAR', icon: '◈' },
  { path: '/database', label: 'Database Master', icon: '◈' },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [showPengaturan, setShowPengaturan] = useState(
    pengaturanItems.some(item => item.path === location.pathname)
  );
  const [collapsed, setCollapsed] = useState(false);

  const isAdmin = user?.role === 'admin';
  const sidebarWidth = collapsed ? '64px' : '220px';

  return (
    <div style={{ width: sidebarWidth, minHeight: '100vh', backgroundColor: '#00843D', display: 'flex', flexDirection: 'column', flexShrink: 0, transition: 'width 0.25s ease' }}>
      {/* Logo + Hamburger */}
      <div style={{ padding: '14px', borderBottom: '1px solid rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <button
          onClick={() => setCollapsed(!collapsed)}
          title={collapsed ? 'Perluas menu' : 'Ciutkan menu'}
          style={{
            width: '30px', height: '30px', minWidth: '30px', borderRadius: '6px', border: 'none',
            backgroundColor: 'rgba(255,255,255,0.15)', cursor: 'pointer',
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '3px',
          }}
        >
          <span style={{ width: '14px', height: '2px', backgroundColor: 'white', borderRadius: '1px', transition: 'transform 0.2s ease' }}></span>
          <span style={{ width: '14px', height: '2px', backgroundColor: 'white', borderRadius: '1px' }}></span>
          <span style={{ width: '14px', height: '2px', backgroundColor: 'white', borderRadius: '1px' }}></span>
        </button>
        {!collapsed && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', overflow: 'hidden' }}>
            <div style={{ width: '34px', height: '34px', backgroundColor: 'white', borderRadius: '7px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <span style={{ color: '#00843D', fontWeight: 'bold', fontSize: '10px' }}>PSRI</span>
            </div>
            <div style={{ whiteSpace: 'nowrap' }}>
              <div style={{ color: 'white', fontWeight: 'bold', fontSize: '12px' }}>PSRI Dashboard</div>
              <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '10px' }}>ULTG Paser</div>
            </div>
          </div>
        )}
      </div>

      {/* User */}
      <div style={{ padding: collapsed ? '10px 0' : '10px 14px', borderBottom: '1px solid rgba(255,255,255,0.15)', display: 'flex', justifyContent: collapsed ? 'center' : 'flex-start' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{ width: '30px', height: '30px', backgroundColor: 'rgba(255,255,255,0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <span style={{ color: 'white', fontWeight: 'bold', fontSize: '12px' }}>{user?.nama?.[0] || 'U'}</span>
          </div>
          {!collapsed && (
            <div style={{ overflow: 'hidden' }}>
              <div style={{ color: 'white', fontSize: '12px', fontWeight: '600', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.nama}</div>
              <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '10px', textTransform: 'capitalize' }}>{user?.role}</div>
            </div>
          )}
        </div>
      </div>

      {/* Menu */}
      <nav style={{ flex: 1, padding: '8px' }}>
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link key={item.path} to={item.path} title={collapsed ? item.label : undefined} style={{
              display: 'flex', alignItems: 'center', gap: '8px', justifyContent: collapsed ? 'center' : 'flex-start',
              padding: collapsed ? '8px 0' : '8px 12px', borderRadius: '7px', marginBottom: '2px',
              fontSize: '12px', textDecoration: 'none',
              backgroundColor: isActive ? 'white' : 'transparent',
              color: isActive ? '#00843D' : 'rgba(255,255,255,0.85)',
              fontWeight: isActive ? '600' : '400',
            }}>
              <span style={{ fontSize: '14px', width: '16px', textAlign: 'center', flexShrink: 0 }}>{item.icon}</span>
              {!collapsed && <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.label}</span>}
            </Link>
          );
        })}

        {/* Pengaturan dropdown - hanya admin */}
        {isAdmin && (
          <div style={{ marginTop: '4px' }}>
            <button onClick={() => setShowPengaturan(!showPengaturan)}
              title={collapsed ? 'Pengaturan' : undefined}
              style={{
                width: '100%', display: 'flex', alignItems: 'center', justifyContent: collapsed ? 'center' : 'space-between',
                padding: collapsed ? '8px 0' : '8px 12px', borderRadius: '7px', border: 'none',
                backgroundColor: showPengaturan ? 'rgba(255,255,255,0.15)' : 'transparent',
                color: 'rgba(255,255,255,0.85)', fontSize: '12px', cursor: 'pointer',
              }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '14px', width: collapsed ? 'auto' : '16px', textAlign: 'center' }}>⚙</span>
                {!collapsed && <span>Pengaturan</span>}
              </div>
              {!collapsed && (
                <span style={{ fontSize: '10px', color: 'rgba(255,255,255,0.6)' }}>
                  {showPengaturan ? '▲' : '▼'}
                </span>
              )}
            </button>

            {showPengaturan && (
              <div style={{ marginLeft: collapsed ? '0' : '14px', marginTop: '2px' }}>
                {pengaturanItems.map((item) => {
                  const isActive = location.pathname === item.path;
                  return (
                    <Link key={item.path} to={item.path} title={collapsed ? item.label : undefined} style={{
                      display: 'flex', alignItems: 'center', gap: '8px', justifyContent: collapsed ? 'center' : 'flex-start',
                      padding: collapsed ? '7px 0' : '7px 12px', borderRadius: '7px', marginBottom: '2px',
                      fontSize: '11px', textDecoration: 'none',
                      backgroundColor: isActive ? 'white' : 'transparent',
                      color: isActive ? '#00843D' : 'rgba(255,255,255,0.75)',
                      fontWeight: isActive ? '600' : '400',
                    }}>
                      <span style={{ fontSize: '13px', width: '16px', textAlign: 'center', flexShrink: 0 }}>{item.icon}</span>
                      {!collapsed && <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.label}</span>}
                    </Link>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </nav>

      {/* Logout */}
      <div style={{ padding: '8px', borderTop: '1px solid rgba(255,255,255,0.15)' }}>
        <button onClick={() => { logout(); navigate('/login'); }}
          title={collapsed ? 'Keluar' : undefined}
          style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: collapsed ? 'center' : 'flex-start', gap: '8px', padding: collapsed ? '8px 0' : '8px 12px', borderRadius: '7px', border: 'none', backgroundColor: 'transparent', color: 'rgba(255,255,255,0.7)', fontSize: '12px', cursor: 'pointer' }}>
          <span style={{ fontSize: '14px' }}>⏻</span>
          {!collapsed && <span>Keluar</span>}
        </button>
      </div>
    </div>
  );
}
